import { render, staticRenderFns } from "./Conclusion.vue?vue&type=template&id=32960e1e&scoped=true&"
import script from "./Conclusion.vue?vue&type=script&lang=js&"
export * from "./Conclusion.vue?vue&type=script&lang=js&"
import style0 from "./Conclusion.vue?vue&type=style&index=0&id=32960e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32960e1e",
  null
  
)

export default component.exports